import { useMemo, useState, useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { ErrorMessage } from '@calendly/form'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import styled from 'astroturf/react'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'

import { Settings } from 'services/settings'
import RoutesHelper from 'services/asset-path'
import { useI18n } from 'locales'

import { stripeClientSecretSelector } from '../../../selectors/payment'

import { fetchPackageClientSecret } from './thunks'
import _LoadingPlaceholder from "stripe_container-LoadingPlaceholder.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/payment/stripe_container.js?styleId=LoadingPlaceholder";


const LoadingPlaceholder = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingPlaceholder",
  styles: _LoadingPlaceholder
})

const PackageStripeContainer = ({ stripeAccount, children }) => {
  const { i18n } = useI18n()
  const [error, setError] = useState(null)
  const { packageUuid } = useParams()
  const stripePromise = useMemo(() => loadStripe(Settings.stripe.publishable_key, { stripeAccount }), [stripeAccount])
  const stripeClientSecret = useSelector(stripeClientSecretSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    if (packageUuid) {
      dispatch(fetchPackageClientSecret(packageUuid))
    }
  }, [dispatch, packageUuid])

  useEffect(() => {
    async function awaitStripePromise() {
      try {
        await stripePromise
        setError(null)
      } catch (e) {
        setError(i18n.t('errors.billing.card.payment_form_not_loaded'))
      }
    }
    awaitStripePromise()
  }, [i18n, stripePromise])

  if (error) {
    return <ErrorMessage message={error} />
  }

  const options = {
    locale: i18n.locale,
    fonts: [{ cssSrc: RoutesHelper.assetUrl('external/proxima-nova.css') }],
  }

  if (stripeClientSecret.status !== 'loaded') {
    return <LoadingPlaceholder />
  }

  if (stripeClientSecret.status === 'loaded') options.clientSecret = stripeClientSecret.value

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  )
}

export default PackageStripeContainer
